import { FC } from 'react';

import { useLkBasePath } from '../../../../../hooks/use-lk-base-path';
import { ArrowsIntegration1V4Icon } from '../../../../icons/ArrowsIntegration1V4Icon';
import { ArrowsIntegration2V4Icon } from '../../../../icons/ArrowsIntegration2V4Icon';
import { ArrowsIntegration3V4Icon } from '../../../../icons/ArrowsIntegration3V4Icon';
import { ArrowsIntegration4V4Icon } from '../../../../icons/ArrowsIntegration4V4Icon';
import { Box } from '../../../common/Box';
import { ButtonLink } from '../../../common/ButtonLink';
import { Flex } from '../../../common/Flex';
import { Text } from '../../../common/Text';

import styles from './IntegrationSection.module.scss';


export const IntegrationSection: FC = () => {
  const lkBasePath = useLkBasePath();

  return (
    <Flex direction={'column'} gap={4} className={styles.root}>
      <Flex direction={'column'} gap={4}>
        <Text type={'h2'}>
          Accept payments globally — <br /> with a single integration
        </Text>

        <Text type={'body16'} color={'white50'} className={styles.description}>
          Launch fast, expand to new markets, and keep full visibility across providers, methods, and currencies
        </Text>
      </Flex>

      <div className={styles.grid}>
        <Box
          iconIn={<ArrowsIntegration1V4Icon />}
          iconOut={<ArrowsIntegration4V4Icon />}
          title="Add methods without reworking core integration"
          description="Cards / Wallets / Bank transfers APMs / Instant rails"
        />

        <Box
          iconIn={<ArrowsIntegration2V4Icon />}
          iconOut={<ArrowsIntegration3V4Icon />}
          title="Payments worldwide"
          description="Process in the regions your customers actually pay from"
        />

        <Box
          iconIn={<ArrowsIntegration3V4Icon />}
          iconOut={<ArrowsIntegration2V4Icon />}
          title="Clear operational view for support, finance, risk teams"
          description="Consolidated information on wallets, statistics and gates for the selected time period"
        />

        <Box
          iconIn={<ArrowsIntegration4V4Icon />}
          iconOut={<ArrowsIntegration1V4Icon />}
          title="One consistent API layer across multiple integrations"
          description="No new API per provider — standard objects, webhooks, and idempotency"
        />
      </div>

      <ButtonLink href={`${lkBasePath}/registration`} isOutsideLink>
        Start processing
      </ButtonLink>
    </Flex>
  );
};
